import { motion } from "framer-motion";
import { SmartImage } from "./SmartImage";
import { useApp } from "../context/AppContext";
import { useTranslation } from "../i18n";

export const About = () => {
  const { lang, hasImage } = useApp();
  const t = useTranslation(lang);

  return (
    <section id="about" data-testid="about-section" className="relative py-16 md:py-24 lg:py-36 bg-[#0A0A0A] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
        >
          <span className="overline">{t.about.overline}</span>
          <h2 className="font-serif-q5 text-4xl md:text-5xl mt-4 text-white leading-tight">
            {t.about.title}
          </h2>
          <div className="divider-gold my-8" style={{ width: 80 }}></div>
          <p className="text-neutral-300 text-lg leading-relaxed mb-5">{t.about.p1}</p>
          <p className="text-neutral-400 leading-relaxed mb-10">{t.about.p2}</p>

          <div className="grid grid-cols-3 gap-4 border-t border-q5 pt-8">
            <div data-testid="about-stat-1">
              <p className="font-serif-q5 text-4xl md:text-5xl text-gold">4,6</p>
              <p className="text-[11px] uppercase tracking-[0.2em] text-neutral-400 mt-1">{t.about.stat1_label}</p>
            </div>
            <div data-testid="about-stat-2">
              <p className="font-serif-q5 text-4xl md:text-5xl text-gold">165+</p>
              <p className="text-[11px] uppercase tracking-[0.2em] text-neutral-400 mt-1">{t.about.stat2_label}</p>
            </div>
            <div data-testid="about-stat-3">
              <p className="font-serif-q5 text-4xl md:text-5xl text-gold">25+</p>
              <p className="text-[11px] uppercase tracking-[0.2em] text-neutral-400 mt-1">{t.about.stat3_label}</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="grid grid-cols-2 gap-3 md:gap-4 h-[380px] md:h-[560px]"
        >
          <div className="space-y-4">
            <div className="overflow-hidden h-2/3 border border-q5">
              <SmartImage slot="about-1" hasImage={hasImage("about-1")} alt="Q5 · 1" className="w-full h-full" imgClassName="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="overflow-hidden h-1/3 border border-q5">
              <SmartImage slot="about-2" hasImage={hasImage("about-2")} alt="Q5 · 2" className="w-full h-full" imgClassName="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
          </div>
          <div className="pt-12 space-y-4">
            <div className="overflow-hidden h-1/3 border border-q5">
              <SmartImage slot="about-3" hasImage={hasImage("about-3")} alt="Q5 · 3" className="w-full h-full" imgClassName="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="overflow-hidden h-2/3 border border-q5">
              <SmartImage slot="about-4" hasImage={hasImage("about-4")} alt="Q5 · 4" className="w-full h-full" imgClassName="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
